/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-07-25 17:12:11
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from 'react';

import { BsyWidget } from '../BsyWidget';
import './index.css'

class BsyTextTag extends BsyWidget {


    constructor(props) {
        super(props);
        this.state = {
            ...props,
        }
    }

    render() {
        return (
            <span className={"bsy-text-tag " + this.props.customCls} style={{
                background: this.props.color,
                border: "1px solid " + this.props.color,
                color: '#fff',
            }}>{this.props.text}</span>
        );
    }


}

export default BsyTextTag;